module.exports = __webpack_public_path__ + "img/4a946d0.svg";